import Vue from 'vue'
import VueRouter from 'vue-router'
import AppRoutes from './routes/app' 
import LoginRoutes from './routes/login'
import TicketsRoutes from './routes/tickets'
import NotFoundRoute from './routes/not-found'
import VideoCallRoutes from './routes/videocall'
import requireAuth from './auth'
import SoftphoneRoute from './routes/softphone-widget'

Vue.use(VueRouter)

const routes = [
	...LoginRoutes,
	...VideoCallRoutes,
	...AppRoutes,
	...TicketsRoutes,
	...SoftphoneRoute,
	...NotFoundRoute 
]

const router = new VueRouter({
	mode: 'history',
	routes
})

router.beforeEach(requireAuth)

export default router